import { ContextBuilder } from '@unboilr/react';

import { useAuth } from '@/app/hooks/useAuth/useAuth';

export const [AuthContextController, useAuthCtx, AuthContext] = ContextBuilder(useAuth, {
  name: 'Auth',
});
